import CenterToFit16 from '@carbon/icons-react/es/center-to-fit/16';
import Filter16 from '@carbon/icons-react/es/filter/16';
import Filter20 from '@carbon/icons-react/es/filter/20';
import { Col, Row as AntRow, Space } from 'antd';
import styled, { css } from 'styled-components';
import { ReactComponent as BiArrow } from 'assets/svgs/sort-arrow.svg';
import { ReactComponent as SortAscending } from 'assets/svgs/sort-ascending.svg';
import { ReactComponent as SortDescending } from 'assets/svgs/sort-descending.svg';
import { Form } from 'components/atoms/form';
import {
  BodyShort02,
  Caption01,
  HelperText01,
  ProductiveHeading04,
  ProductiveHeading06,
  SingleLineEllipsis,
  Text01,
} from 'components/styles';

export const SimpleWrapper = styled.div``;
export const FilterWrapper = styled(SimpleWrapper)`
  margin-bottom: var(--spacing-03);
`;

export const Content = styled.div`
  ${ProductiveHeading04};
  ${SingleLineEllipsis};
  cursor: pointer;
`;

export const DrilldownTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: var(--spacing-03);
`;

export const HelperTextWrapper = styled.span`
  ${HelperText01};
`;
export const Strong = styled.strong`
  margin-bottom: var(--spacing-03);
`;

export const CaptionText = styled.div`
  ${Caption01};
  color: var(--gray-70);
`;

export const BodyShortText = styled.div`
  ${Text01};
  margin-top: var(--spacing-03);
  margin-right: var(--spacing-03);
  color: var(--gray-100);
`;

export const OptionsCol = styled(Col)`
  flex: 0 1 360px;
  padding: var(--spacing-05);
  border-left: solid 1px var(--gray-20);
  height: 100%;
  overflow-y: scroll;
`;

export const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
`;

export const ModalWrapper = styled.div`
  padding: 0;
  height: 80vh;
`;

export const Row = styled(AntRow)`
  height: 100%;
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0;
  padding-bottom: var(--spacing-01) !important;
`;

export const FormItem = styled(Form.Item)`
  margin-bottom: 0;
`;

export const StyledCol = styled.div`
  flex: 1 0;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: var(--spacing-08);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 125px;
  align-items: center;
`;

export const SortIconStyles = css`
  width: var(--spacing-05);
  height: var(--spacing-05);
  margin: 0 var(--spacing-04);
  cursor: pointer;
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--layout-01);
  /* border-bottom: 1px solid #d0d3da; */
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: 90%;
  gap: var(--spacing-03);
`;

export const ListWrapper = styled.div`
  height: 60vh;
`;

export const StyledSpace = styled(Space)`
  width: 100%;
`;

export const InfoIcon = styled(Filter16)`
  color: var(--gray-80);
`;

export const InfoIconLarge = styled(Filter20)`
  color: var(--gray-80);
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  opacity: 0;
  transition: opacity 0.5s;
`;

export const NoSortIcon = styled(BiArrow)`
  margin: 0 var(--spacing-04);
  cursor: pointer;
`;

export const SortAscendingIcon = styled(SortAscending)`
  ${SortIconStyles};
`;

export const SortDescendingIcon = styled(SortDescending)`
  ${SortIconStyles};
`;

export const ModalIconsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const ChartContent = styled.div`
  min-height: 280px;
  position: relative;
`;

export const Title = styled.div`
  ${SingleLineEllipsis};
  flex: 1;
`;

export const ProductiveHeading6 = styled.span`
  ${ProductiveHeading06};
`;

export const BodyShort2 = styled.span`
  ${BodyShort02};
`;

export const ExpandIcon = styled(CenterToFit16)`
  cursor: pointer;
`;
